import { apiClient, extractApiError } from './api';
import { ApiResponse } from '@/types';

// Type definition for Digital Card (based on backend response)
export interface CardDetails {
  cardNumber: string;
  memberNumber: string;
  fullName: string;
  contractNumber: string;
  validUntil: string;
  qrCodeData: string; // The raw data string
}

export interface DigitalCardData {
  card: CardDetails;
  qrCodeUrl: string; // The image data URL
}

class CardService {
  /**
   * Get user's digital card
   */
  async getMyCard(): Promise<DigitalCardData> {
    try {
      const response = await apiClient.get<ApiResponse<DigitalCardData>>(`/cards`);
      return response.data.data!;
    } catch (error) {
      throw extractApiError(error);
    }
  }

  /**
   * Regenerate QR code
   */
  async regenerateCard(): Promise<DigitalCardData> {
    try {
      const response = await apiClient.post<ApiResponse<DigitalCardData>>(`/cards/regenerate`);
      return response.data.data!;
    } catch (error) {
      throw extractApiError(error);
    }
  }

  /**
   * Download card as PDF
   */
  async downloadCardPDF(): Promise<Blob> {
    try {
      const response = await apiClient.get(`/cards/download`, {
        responseType: 'blob',
        headers: {
          Accept: 'application/pdf',
        },
      });
      return response.data;
    } catch (error) {
      throw extractApiError(error);
    }
  }
}

export const cardService = new CardService();
export default cardService;
